export const landingAssets = {
  heroDashboard: {
    type: 'image',
    src: '/landing/hero-dashboard.svg',
    alt: 'NexusWorkforce360 live operations dashboard preview',
  },
  adminOperations: {
    type: 'image',
    src: '/landing/admin-operations.svg',
    alt: 'NexusWorkforce360 admin operations screen showing jobs, assignments, timesheets, and organizations',
  },
  supervisorMap: {
    type: 'image',
    src: '/landing/supervisor-map.svg',
    alt: 'NexusWorkforce360 supervisor map showing live worker coverage and punch status',
  },
  workerMobile: {
    type: 'image',
    src: '/landing/worker-mobile.svg',
    alt: 'NexusWorkforce360 worker mobile screen showing assigned shift and punch actions',
  },
} as const
